import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
  selector: 'tpc-air-travel-miles',
  templateUrl: './air-travel-miles.component.html',
  styleUrls: ['./air-travel-miles.component.css']
})
export class AirTravelMilesComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    private countDefaultValue = 1;
    private _range: Array<number> = [33, 66];

    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    get range(): Array<number> {
        return this._range;
    }

    private createForm() {
        this._form = this.fb.group({
            mile: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(1),
                CustomValidators.max(999999999999),
                CustomValidators.digits]],
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    onRangeChange(value) {
        this._range = value;
    }

    next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'airTravel';
        let params = {
            calculateBy: 'miles',
            mileLong: this.getFV(100 - this._range[1]),
            mileMed: this.getFV(this._range[1] - this._range[0]),
            mileShort: this.getFV(this._range[0])
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                this.emissionService.setEmission({
                    category: Constants.categories.business.travel,
                    emission: {
                        emission: input.emmission,
                        emissionTrees: input.emissionTrees,
                        DollarAmt: input.DollarAmt,
                        DollarAmtMonthly: input.DollarAmtMonthly
                    }
                });

                this.footerService.skip();
                this.spinner.hide();
            }
        );
    }

    getFV(param) {
        let miles = this.form.get('mile').value;
        return miles / 100 * param;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/air-travel/air-travel-miles/air-travel-miles.component.ts